import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Cargo',
  path: '/pessoal/pescargo',
  name: 'pescargo',
  component: () => import('@/views/pessoal/pescargo/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.CARGOSEFUNCOESNOVO_MENU_1400700799],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Cargo',
  path: '/pessoal/pescargo/cadastro/:id?',
  parent: 'pescargo',
  name: 'pescargo_create',
  component: () => import('@/views/pessoal/pescargo/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.CARGOSEFUNCOESNOVO_MENU_1400700799],
  },
  goesToMenu: true,
 },
]
